'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autofill = undefined;

var _reduxForm = require('redux-form');

var autofill = exports.autofill = function autofill(formName, values) {
  return function (dispatch) {
    var keys = Object.keys(values);

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];
      var value = values[key];
      dispatch((0, _reduxForm.change)(formName, key, value));
    }
  };
};